import React, { createContext, useContext, useState } from 'react';
//import { useJsApiLoader } from '@react-google-maps/api';
import { APIProvider } from '@vis.gl/react-google-maps';
import { API_ENDPOINTS } from "../Constants";

// Create context to hold map loading state
const MapContext = createContext();

export const UseMap = () => {
  return useContext(MapContext);
};
const libraries = ["places", "drawing" , 'routes'];
const GoogleMapLoader = ({ children }) => {
  return (
    <APIProvider
      apiKey={API_ENDPOINTS.GMAP_API} // Use your actual API key
      libraries={libraries}
	version="quarterly"
    >
      <MapContext.Provider value={{ isLoaded: true }}>
        {children}
      </MapContext.Provider>
    </APIProvider>
  );
};

export default GoogleMapLoader;